/**
 * 1.在请求拦截的地方调用方法：getSigndata()
 * 2.将返回值写到header里面
 *
 * 安装三个插件
 * npm install crypto-js
 * npm install js-md5
 * npm install uuid
 *
 * useStore：自己项目里面的pinia数据存储
 * store.userInfo.mobile：项目里存的当前登录人的手机号
 * store.token：项目里面token存的地方
 *
 *
 * import.meta.env.VITE_BASE_ACCESSID：项目名字
 * import.meta.env.VITE_BASE_HmacSHAKEY：加密的key
 * 项目名字和加密的key值从这里获取（每个项目的都不一样）
 * https://wiki.tailgvip.com/pages/viewpage.action?pageId=98673
 *
 *
 */

import CryptoJS from "crypto-js/crypto-js";
import md5 from "js-md5";
import { v4 as uuidv4 } from "uuid";
import store from "../store/index";

/**
 * 加密请求
 * @param {*} config axios请求前拦截的参数
 * @returns
 */
export function getSigndata(config) {
    console.log(process.env.VUE_APP_ACCESSID, process.env.VUE_APP_HmacSHAKEY);
    const stores = store.state;
    const headers = {
        accessid: process.env.VUE_APP_ACCESSID,
        method: "",
        timestamp: "",
        traceid: "",
        token: localStorage.getItem("appToken") || "",
        url: "",
        sign: "",
    };
    headers.method = config.method.toUpperCase();
    headers.timestamp = new Date().getTime();
    headers.url = config.baseURL + config.url;
    // console.log(config.data ||config.params||store.userInfo.mobile)
    //getTraceid需要的值可以是请求体或者手机号都可以
    headers.traceid = getTraceid(config.data || config.params || stores.openId);
    let str = "";
    //根据自己的项目来判断是否有token
    if (localStorage.getItem("appToken")) {
        str = `accessid=${headers.accessid}&method=${headers.method}&timestamp=${headers.timestamp}&traceid=${headers.traceid}&token=${stores.token}&url=${headers.url}`;
    } else {
        str = `accessid=${headers.accessid}&method=${headers.method}&timestamp=${headers.timestamp}&traceid=${headers.traceid}&url=${headers.url}`;
    }
    console.log("加密字符串", str, process.env.VUE_APP_HmacSHAKEY);
    let test = CryptoJS.HmacSHA256(str, process.env.VUE_APP_HmacSHAKEY);
    // 使用16进制的方法加密，输出字符串
    let testStr = CryptoJS.enc.Hex.stringify(test);
    headers.sign = testStr;
    return headers;
}

function getTraceid(data) {
    const time = new Date();
    let m1 = data + time.getTime();
    let m1md5 = md5(m1);
    let m1md5sub = m1md5.substring(m1md5.length - 8);
    let m2 = `${time.getMinutes()}${time.getSeconds()}${time.getMilliseconds()}`;
    let m3 = uuidv4();
    let m3Sub = m3.substring(m3.length - 8);

    return `${m1md5sub}${m2}${m3Sub}`;
}
